import React, { useState, useEffect, useContext } from 'react'
import './affidavit.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faFileLines, faQuestionCircle, faRefresh, faSearch, faTrash, faClose, faFileCirclePlus } from '@fortawesome/free-solid-svg-icons'
import { Link,useParams } from 'react-router-dom'
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import BackLoader from '../../components/backloader'
import TopBar from '../../components/topbar'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import JisAlert from '../../components/jisalert'

function AffidavitDocuments() {
    const {refid} = useParams();
    const {  profile } = useContext(ShareContext)
   // console.log(profile);
    const [openSuccess, setOpenSuccess] = useState(false)
  //  const {temptype} = useParams();
    const [deleteBox, setDeleteBox] = useState(false)
    const tempUrl= `${Constants.apiUrl}/gazette/templates/affidavit`;

    var url=`${Constants.apiUrl}/gazette/affidavits/${profile.username}`;

    const [templates, setTemplates]=useState([]);
    const [openTemp, setOpenTemp ] =useState(false);
    const [filterTemps, setFilterTemps]=useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [index, setIndex] =useState(-1);
    const [search, setSearch] = useState('');
    const [docs, setDocs] =useState([]);
    const [config, setConfig]=useState({});
    const [alert, setAlert] = useState({open:false, title:'', subtitle:'', code:-10, data:{}});
    const [isPay, setIsPay] =useState(false);
    const [selectedtempid, setSelectedTempId]=useState(0);
    const [scheduleWindow, setScheduleWindow] = useState(false)
    const [schedule, setSchedule]= useState({});
    const [confirmSelect, setConfirmSelect]=useState(false);
    const [activeSelect, setActiveSelect]= useState({});


    const navigate = useNavigate();
    
    const onCancel=()=>{
      setIsPay(false);
      setSelectedTempId(0);
    }
    const onOk=()=>{
      console.log ('we are here already....')
        if(alert.code==0){
        //  var lk=`/AffidavitDocuments/${alert.data.templateId}/edit/${alert.data.uplineId}`;
           // navigate(lk)
           var a={id: alert.data.docId,caseTitle: 'N/A',caseNumber:'N/A', type:'affidavit',caseFeeId: alert.data.caseFeeId   };
        navigate("/view-document-template", {state: {item:a}});
        }
       
        setAlert({open:false});
    }
    const onCompleted=()=>{
      console.log('alert value');
      console.log(alert);
      var lk=`/AffidavitDocuments/${alert.data.templateId}/edit/${alert.data.uplineId}`;
      console.log(lk);
        navigate(lk)
    }

      useEffect(() => {     
            LoadTemplates();
            
            onConfig();
            if(refid!=undefined){
                //verifiy payment 
                onVerifyPayment();

            }else{
                onLoad();
            }
      }, [])

      const onView=(itm)=>{
        var a={id: itm.id, caseTitle: 'N/A',caseNumber:'N/A', type:'affidavit',caseFeeId: itm.caseFeeId,zoomLink: itm.zoomLink, schedule:itm.schedule   };
        navigate("/view-document-template", {state: {item:a}});
        
    }   

    const onSelectSchedule=(doc)=>{
      setScheduleWindow(true);
      console.log(doc);
   
      setSchedule({...schedule, doc});
  }
  const onSaveSchedule=(doc)=>{
        
    console.log(schedule);
    var sch={docid:schedule.doc.id, zoomLink:schedule.zoom, scheduledBy:profile.username, scheduleDate : (schedule.date+' '+schedule.time)};

  
    const uploadurl=`${Constants.apiUrl}/gazette/schedule/${schedule.doc.id}`
    const formData = new FormData();
      

        // Sending the FormData using fetch
        setIsLoading(true);
        fetch(uploadurl, {
        method: 'POST',
        body: JSON.stringify(sch),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': '',
        },
        })
        .then(response => response.json())
        .then(data => {
            setIsLoading(false);
            if(data.code==0){
                //saved already
                //first upldate the row and show dialog box
                setFilterTemps(filterTemps.map(i => i.id === schedule.doc.id ? {...i, zoomLink:sch.zoomLink, schedule:sch.scheduleDate} : i));

               setSchedule({});
             
               setAlert({open:true, title:'Schedule an Appointment', subtitle:'Meeting Schedule is successful', onOk})
               setScheduleWindow(false)
            }
        })
        .catch(error => {
            console.error('Error:', error);
            setIsLoading(false);
    });
}

      const onVerifyPayment= async()=>{ //doctype=upline always this one
        //for account registration DocumentView
        const url=`${Constants.apiUrl}/gazette/affidavitverify/${refid}`
    
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
           // onLoad();
           console.log(data);
            if(data.code==0 ){
              // navigate(`/AffidavitDocuments/${data.docId}/edit/${data.uplineId}`)
               setAlert({open:true, title:'Payment Status', subtitle:'Payment successful', code:data.code, data})
            }else{
               // setAlert({open:true, title:'Payment Status', subtitle:data.status, code:data.code, data, onOk})
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const LoadTemplates=()=>{
         setIsLoading(true);
         fetch(tempUrl, {
             method: 'GET',
             headers: {
               'Content-type': 'application/json',
             },
           })
             .then((resp) => resp.json())
             .then((data) => {
                 setIsLoading(false);
                 if(data.code==0){
                     setTemplates(data.templates);
                     
                 }
                 
             })
             .catch(error => {
                 console.error(error);
                 setIsLoading(false);
             })
     }

     const onSearch=(ee)=>{
        setSearch(ee);
        if(ee!=''){
        const _filterSearch = docs?.filter(item => {
              const searchValue = item.docUploadLines[0].documentTitle.toLowerCase().includes(ee.toLowerCase()) || item.refid?.toLowerCase().includes(ee.toLowerCase())
          
              return searchValue;
            })
        setFilterTemps(_filterSearch);
        }else{
            setFilterTemps(docs);
        }
      
      }

     const onDelete =()=>{
        setDeleteBox(false);
     }

     const openDelete=(ind)=>{
        setIndex(ind);
        setDeleteBox(true);

     } 

     const onReset=()=>{
        setSearch('');
        setFilterTemps(templates);
     }

     const onNewTemplate=()=>{
       // `/templates/${doc.id}/view`
      // navigate(`/templates/${temptype}/create`)
      //alert('Pending implementation')
      setOpenTemp(true);
     }

     const onCloseTemp=()=>{
        setOpenTemp(false);
        
      }
    
      const onSelectTemplate=(selected)=>{
        setActiveSelect(selected);
       setSelectedTempId(selected.id);
       setConfirmSelect(true);
        onCloseTemp();
       // setIsPay(true);
      }

      const onConfirmSelect=()=>{
        setConfirmSelect(false);
         setIsPay(true);
       }

       const onSelectOthers=()=>{
        setConfirmSelect(false);
        setOpenTemp(true);
       }

      const onLoad= async()=>{
        //for account registration
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
          
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
              var cdocs=[];
              data.docs.forEach(doc => {
                const r= `LSJ/HC/AFF/${doc.docUploadLines[0]?.id}/${retrieveDocYear(doc)}`;
                cdocs.push({...doc, refid:r });
              });
              console.log('after reconstruct')
              console.log(cdocs)
                setDocs(cdocs);
                setFilterTemps(cdocs);
               
            }else {    
                alert(data.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const onConfig= async()=>{
        
        const urls=`${Constants.apiUrl}/gazette/getsettings`;
        console.log(`the calling url ${urls}`);

        try {
           
            const resp = await fetch(urls, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            const data = await resp.json();
           setConfig(data);
            
          } catch (error) {
            console.error(error);
          }   
  }

  const retrieveDocYear=(currectdoc)=>{
    return currectdoc?.uploadDate==null ? moment(new Date()).format("YYYY"): moment(currectdoc?.uploadDate).format("YYYY")
   }

  return (
    <div className='affidavit-table'>
        <Sidebar />
        <div className="body">
            
            <TopBar title="Home/ Templates" />

            <div className="search-table">
                <div className="form-inp">
                  
                    <input type="text" placeholder='Search by Title/ Ref ID' id='search-title' value={search} onChange={(e)=> onSearch(e.target.value)}/>
                </div>
                <button className='red'>Search <FontAwesomeIcon icon={faSearch} /></button>
                {/* <div className="reset-fields" onClick={onReset}>
                    <p>Reset Fields</p>
                    <FontAwesomeIcon icon={faRefresh} />
                </div> */}
            </div>
            <div className="aff-table">
                <div className="all-div">
                    <FontAwesomeIcon icon={faFileLines} />
                    <h3 style={{flex:1}}> Affidavit Templates</h3>
                    {(profile.role=='LegalCounsel' || profile.role=='Customer')  && <div style={{textAlign:'right'}}><button className='black' onClick={onNewTemplate}> New Affidavit</button></div>}
                    
                </div>
                <div className="table-wrapper">
                    {(profile.role=='LegalCounsel' || profile.role=='Customer') && <p><stron>Click 'New Affidavit' to create Affidavit Document</stron> </p>}
                    <table>
                        <thead>
                            <tr>
                                <th>AFF ID</th>
                                <th>Affidavit title</th>
                                <th>Date Created</th>
                                <th>Type</th>
                                <th>Zoom Link</th> 
                                <th>Schedule Date</th>
                                <th>View Document</th>
                                
                                
                                {(profile.role=='CommissionerForOaths' || profile.role=='e-CFO'|| profile.role=='e-Commissioner for Oaths'  || profile.role=='ACR' || profile.role=='e-ACR') && 
                                    <th>Schedule</th>  }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                filterTemps.map((doc, i) => { return (
                                    <tr key={i}>
                                        <td>{ `LSJ/HC/AFF/${doc.docUploadLines[0]?.id}/${retrieveDocYear(doc)}`}</td>
                                        <td>{doc.docUploadLines[0].documentTitle}</td>
                                        
                                        <td>{moment(doc.createDate).format('D MMM, YYYY') }</td>
                                        <td>{'AFFIDAVIT'} </td>
                                        <td className={doc.schedule==null? '' :'meet-link'}> {doc.schedule!=null && <a href={doc.zoomLink} target='_blank'> Zoom Link </a>}  </td>
                                        <td>{doc.schedule!=null ? moment(doc.schedule).format("dddd, MMMM Do YYYY, h:mm a")  : 'Time not set'}</td>
                                     {doc.caseFeeId>0 && <td className='view-affbtn'>
                                      {doc.isCompleted?<Link to={`/AffidavitDocuments/live/content/${doc.id}`} target='_blank'><button type='button' target="_blank"> Print <FontAwesomeIcon icon={faAngleRight} /></button></Link>
                                        : <button type='button' onClick={()=> onView(doc)}> View <FontAwesomeIcon icon={faAngleRight} /></button>}
                                        
                                       
                                        </td>}   
                                    

                                        {(profile.role=='CommissionerForOaths' || profile.role=='e-CFO'|| profile.role=='e-Commissioner for Oaths'  || profile.role=='ACR' || profile.role=='e-ACR') && 
                                      <td >  <button className='black'  onClick={() => onSelectSchedule(doc) }>{doc.schedule==null?'Schedule':'Reschedule' } </button></td>}
                                    </tr>
                                )})
                            } 
                        </tbody>
                    </table> 
                </div>
            </div>
         {deleteBox && <div className={ "delete-box open" }>
                <div className="delete-wrap">
                    <FontAwesomeIcon icon={faQuestionCircle} />
                    <h2>Do you want to delete this Affidavit Template?</h2>
                    <div className="del-btns">
                        <button className='red' onClick={onDelete}>Yes</button>
                        <button className='black' onClick={() => setDeleteBox(false)}>Cancel</button>
                    </div>
                </div>
            </div>}   
            {openSuccess && <div className={ "success open" }>
                <div className="success-box">
                    <h2>Successful</h2>
                    <p> Template deleted successfully</p>
                    <button className='red' onClick={()=> setOpenSuccess(false)}>Continue</button>
                </div>
            </div>}

        </div>
        <BackLoader open={isLoading}  />
     {alert.open && <JisAlert {...alert} onOk={onOk} />} 
       
        {openTemp && 
          <div className='upload'><div className={ "dialog open" }>
            <div className="container">
                <div className="heading">
                    <h2>AFFIDAVIT TEMPLATES</h2>
                    <FontAwesomeIcon icon={faClose} onClick={() => onCloseTemp()}/>
                </div>
                <div className="body">
                 { templates.map((item, id) => { return (   

                    <div className="template" key={id} onClick={() =>onSelectTemplate(item)} title={item.id==89?'This option is for any type of affidavit not already specified':item.note}>
                        <h3>{item.title} </h3>
                       {item.id==89 && <span style={{color:'red',margin:5}}>This option is for any type of affidavit not already specified</span>} 
                        <div className="create">
                            <p>Select Template</p>
                            <FontAwesomeIcon icon={faFileCirclePlus} />
                        </div>
                        <div className="line"></div>
                    </div>
                   )})}   
                 
                </div>
            </div>
        </div></div>  
          }  
           {isPay && <div className={ "success open" }>
                <div className="success-box">
                    <h2>{Constants.formatCurrency(config.affidavitAmount) }</h2>
                    <p>Payment for Affidavit  </p>
                    <form className='form-inp' action='/paystack.html'>
                        <input type='hidden' name="name" value={profile.firstName}  />
                        <input type='hidden' name="email" value={profile.email}   />
                        <input type='hidden' name="phone" value={profile.phone}   />
                        <input type='hidden' name="returnurl" value={`${Constants.baseurl}/templates/AffidavitDocuments/`}   />
                        <input type='hidden' name="amount" value={config.affidavitAmount} />
                        <input type='hidden' name="docref" value={`${selectedtempid}-0-${profile.userid}-${profile.username}`} />
                      <button className='red' type='submit'>Pay Now</button>  <button className='red' onClick={onCancel} type='button'>Cancel</button> 
                    </form>  
                </div>
            </div>} 
            {confirmSelect && <div className={ "success open" }>
                <div className="success-box">
                    <h2>Confirm Template Selection</h2>
                    <p>Please confirm if you selected the correct template '{activeSelect.title}''. Click 'Yes' to continue to payment or 'No' to select a different template</p>
                    
                    <div><button className='red' onClick={onConfirmSelect} type='button'>Yes</button>  <button className='red' onClick={onSelectOthers} type='button'>No</button> </div>
                </div>
            </div>} 
            {scheduleWindow && <div className={"pick-date open" }>
                <div className="heading">
                    <h2>Appointment Details</h2>
                  
                </div>
               

                <input type="text" placeholder='Zoom Link' value={schedule.zoom} onChange={(e)=>setSchedule({...schedule, zoom:e.target.value})} />
              

                <input type="date" placeholder='Zoom meeting date' value={schedule.date} onChange={(e)=>setSchedule({...schedule, date:e.target.value})} />
                

                <input type="time" placeholder='Zoom meeting time' value={schedule.time} onChange={(e)=>setSchedule({...schedule, time:e.target.value})} />

               
                <div className="date-btns">
                    <button className="red" onClick={() => setScheduleWindow(false)}>Cancel</button>
                    <button className="black" onClick={onSaveSchedule }>Schedule Appointment</button>
                </div>
            </div>}
    </div>
  )
}

export default AffidavitDocuments